import React, { useRef, useState } from 'react';
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  TextField,
  MenuItem,
  Typography
} from '@mui/material';
import axios from 'axios';
import JoditEditor from "jodit-react";
import PreviewFastJobPosting from './PreviewFastJobPosting';

const steps = ['Kişisel Bilgiler', 'Firma Bilgileri', 'İlan Bilgileri 1', 'İlan Bilgileri 2', 'Önizleme', 'İlan Yayınlama'];


const provinces = [
  "Genel","Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
  "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
  "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
  "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
  "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
  "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
  "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
  "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
  "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
  "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak" ,"Yurt Dışı"
]; 
const positionCategories = [
  "Araştırma Geliştirme (AR-GE)",
  "Geri Ödeme/Pazara Erişim",
  "Klinik Destek/Aplikasyon",
  "Kalite/Belgelendirme/Mevzuat",
  "Lojistik ve Tedarik Zinciri",
  "Pazarlama/Ürün Yönetimi",
  "Satış",
  "Teknik Servis",
  "Teknoloji Yönetimi",
  "Test/Kalibrasyon/Muayene",
  "Üretim",
  "Diğer"
];
const experienceOptions = ['0-2', '2-5', '5-10', '10+'];

const FastJobPosting = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    company_name: '',
    company_logo: null,
    about_company: '',
    website: '',
    job_type: '',
    work_model: '',
    position_category: '',
    position_name: '',
    city: '',
    position_tags: '',
    job_description: '',
    qualifications: '',
    experience_required: '',
    other_details: '',
    job_link: ''
  });
   const [onaylandi, setOnaylandi] = useState(false);

  const job_descriptionEditor = useRef(null);
  const qualificationsEditor = useRef(null);
  const other_detailsEditor = useRef(null);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, company_logo: e.target.files[0] }));
  };

  const handleNext = () => {
  if (activeStep === 3) {
      const requiredFields = Object.keys(formData).filter(
    key => key !== 'other_details' && key !== 'position_tags'
  );
    for (let key of requiredFields) {
      const value = formData[key];
      if (
        (typeof value === 'string' && value.trim() === '') ||
        (key === 'company_logo' && !value)
      ) {
        alert(`Lütfen önizlemeyi görebilmek için (*) ile belirtilen bölümleri doldurunuz!\n`);
        return;
      }
    }
  }

  // Eğer activeStep 3 değilse veya kontroller geçerse bir sonraki adıma geç
  setActiveStep((prev) => prev + 1);
};

  const handleBack = () => setActiveStep((prev) => prev - 1);

const handleSubmit = async () => {
  // Zorunlu alanlar kontrolü (other_details ve position_tags hariç)
  const requiredFields = Object.keys(formData).filter(
    key => key !== 'other_details' && key !== 'position_tags'
  );

  for (let key of requiredFields) {
    const value = formData[key];
    if (
      (typeof value === 'string' && value.trim() === '') || 
      (key === 'company_logo' && !value)
    ) {
      alert(`Lütfen tüm zorunlu alanları doldurun! Eksik alan: ${key}`);
      return;
    }
  }

  // E-posta format kontrolü
  const email = formData.email.trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    alert("Geçerli bir e-posta adresi giriniz.");
    return;
  }

  // FormData oluştur
  const form = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    form.append(key, value);
  });

  try {
    const response = await axios.post('https://kariyer.biyomed.net/api/posts/create-fast-post', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (response.status === 200) {
      alert('İlanınız başarıyla kayıt edildi. Gerekli süreci e-posta adresinizden kontrol edebilirsiniz. İlanınız onay aldığı durumda sitemizde yayınlanacaktır.');
      window.location.href="/"
    } else {
      alert('Gönderim başarısız!');
    }
  } catch (err) {
    console.error("Form gönderim hatası:", err);
    alert('Bir hata oluştu: ' + err.message);
  }
};


const renderStepContent = (step) => {
  switch (step) {
    case 0:
      // Kişisel Bilgiler (aynı kalır)
      return (
        <Box display="flex" flexDirection="column" gap={2}>
          <strong style={{fontSize:12, color:"red"}}>*Bu bilgiler, sizinle iletişime geçebilmemiz için gereklidir. İlan sayfasında bu bilgiler kesinlikle gösterilmeyecektir.</strong>
          <TextField label="Ad Soyad" value={formData.full_name} onChange={handleChange('full_name')} required />
          <TextField label="E-posta" type="email" value={formData.email} onChange={handleChange('email')} required />
          <TextField label="Telefon" placeholder="(5xx) xxx xx xx" value={formData.phone} onChange={handleChange('phone')} required />
        </Box>
      );

    case 1:
      // Firma Bilgileri (aynı kalır)
      return (
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField label="Firma/Sağlık Kuruluşu Adı" value={formData.company_name} onChange={handleChange('company_name')} required />
          <Button variant="outlined" component="label">
            Firma/Sağlık Kuruluşu Logo Yükle * 
            <input type="file" hidden onChange={handleFileChange} required />
          </Button>
          {formData.company_logo && (
            <Typography variant="body2">
              Yüklenen dosya: {formData.company_logo.name}
            </Typography>
          )}
          <TextField label="Firma/Sağlık Kuruluşu Hakkında" multiline rows={4} value={formData.about_company} onChange={handleChange('about_company')}  required/>
          <TextField label="Firma Web Sitesi" type="url" value={formData.website} onChange={handleChange('website')} required />
        </Box>
      );

    case 2:
      // İlan Bilgileri 1
      return (
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField label="İlan Türü" select value={formData.job_type} onChange={handleChange('job_type')} required>
            <MenuItem value={"Is"}>İş</MenuItem>
            <MenuItem value={"Staj"}>Staj</MenuItem>
          </TextField>
          <TextField label="Çalışma Şekli" select value={formData.work_model} onChange={handleChange('work_model')} required>
            <MenuItem value={"Hibrit"}>Hibrit</MenuItem>
            <MenuItem value={"Uzaktan"}>Uzaktan</MenuItem>
            <MenuItem value={"Is yerinde"}>İş yerinde</MenuItem>
          </TextField>
          <TextField label="Pozisyon Kategorisi" select value={formData.position_category} onChange={handleChange('position_category')} required>
            {positionCategories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </TextField>
          <TextField label="Pozisyon Adı" value={formData.position_name} onChange={handleChange('position_name')} required />
          <TextField label="İl" select value={formData.city} onChange={handleChange('city')} required>
            {provinces.map((il) => (
              <MenuItem key={il} value={il}>
                {il}
              </MenuItem>
            ))}
          </TextField>
          <TextField label="Pozisyon Etiketleri" value={formData.position_tags} onChange={handleChange('position_tags')} />
        </Box>
      );

    case 3:
      // İlan Bilgileri 2
      return (
        <Box display="flex" flexDirection="column" gap={2}>
          <label>İş Tanımı *</label>
          <JoditEditor
            ref={job_descriptionEditor}
            value={formData.job_description}
            onBlur={(newContent) => setFormData({ ...formData, job_description: newContent })}
            config={{ placeholder: "İş Tanımı" }}
          />
          <label>Aranan Nitelikler *</label>
          <JoditEditor
            ref={qualificationsEditor}
            value={formData.qualifications}
            onBlur={(newContent) => setFormData({ ...formData, qualifications: newContent })}
            config={{ placeholder: "Aranan Nitelikler" }}
          />
          <TextField label="Aranan Deneyim (Yıl)" select value={formData.experience_required} onChange={handleChange('experience_required')} required>
            {experienceOptions.map((exp) => (
              <MenuItem key={exp} value={exp}>
                {exp}
              </MenuItem>
            ))}
          </TextField>
          <label>Diğer Açıklamalar</label>
          <JoditEditor
            ref={other_detailsEditor}
            value={formData.other_details}
            onBlur={(newContent) => setFormData({ ...formData, other_details: newContent })}
            config={{ placeholder: "Diğer Açıklamalar" }}
          />
          <TextField label="İlan Linki" value={formData.job_link} onChange={handleChange('job_link')} required />
        </Box>
      );

    case 4:
      return <PreviewFastJobPosting post={formData} />;
    case 5:
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "40px auto",
        padding: "20px 30px",
        backgroundColor: "#f9f9f9",
        borderLeft: "6px solid #007BFF",
        borderRadius: "8px",
        fontFamily: "Segoe UI, sans-serif",
        fontSize: "16px",
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      <h2 style={{ marginBottom: "20px", color: "#007BFF" }}>Dikkat</h2>
      <p>
        Biyomed Kariyer sayfasında yer alan “Hızlı İlan Girişi” alanı, firmaların kendi ilanlarını doğrudan paylaşmalarına olanak tanımaktadır. Bu alana girilen içeriklerin doğruluğu ve güncelliği tamamen ilanı paylaşan firma veya kişilerin sorumluluğundadır.
        <br /><br />
        Yanıltıcı, eksik, hatalı veya gerçeğe aykırı bilgi paylaşımı durumunda sorumluluk ilan sahibine aittir. Biyomed, bu içeriklerin doğruluğunu taahhüt etmez ve içerik kaynaklı oluşabilecek herhangi bir olumsuzlukta sorumluluk kabul etmez.
        <br /><br />
        Ayrıca; firmalar tarafından paylaşılan ilanlarda dil, içerik ve görsel bakımından saygılı, profesyonel ve etik kurallara uygun bir üslup kullanılması zorunludur. Küfür, hakaret, ayrımcı ifadeler, yanıltıcı yönlendirmeler veya kurumlara zarar verebilecek nitelikte içeriklerin paylaşımı kesinlikle yasaktır. Bu tür içeriklerin tespiti halinde ilgili ilanlar yayından kaldırılır ve gerekli önlemler alınarak ilgili firma veya kişinin tekrar ilan vermesi engellenebilir.
        <br /><br />
        İlan paylaşan her firma bu kuralları kabul etmiş sayılır.
      </p>

      <div style={{ marginTop: "30px" }}>
        <label>
          <input
            type="checkbox"
            checked={onaylandi}
            onChange={() => setOnaylandi(!onaylandi)}
            style={{ marginRight: "10px" }}
          />
          Yukarıdaki kuralları okudum ve kabul ediyorum.
        </label>
      </div>

    </div>
  );

    default:
      return null;
  }
};


  return (
    <Box sx={{ width: '100%', maxWidth: activeStep === 4 ? 1000 : 800, mx: 'auto', p: 4, pt:10}}>
      <Typography sx={{marginLeft:activeStep!== 4 ? 33 : 50, marginTop:10}} variant="h4" mb={2}>
        Hızlı İlan Ekle
      </Typography>
      <Stepper activeStep={activeStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box mt={3}>{renderStepContent(activeStep)}</Box>
      <Box mt={3} display="flex" justifyContent="space-between">
        <Button disabled={activeStep === 0} onClick={handleBack}>
          Gerİ
        </Button>
        {activeStep === steps.length - 1 ? (
          <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!onaylandi}>
            Gönder
          </Button>
        ) : (
          <Button variant="contained" onClick={handleNext}>
            İlerİ
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default FastJobPosting;
